import React from "react";

import { Toolbox as Value } from "@reactivated";

import { ScrollNavMenuItemBlock } from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock";
import {
    StreamField,
    StreamFieldBlockMap,
} from "@thelabnyc/thelabui/src/components/StreamField";
import { TableInContainerBlock } from "@thelabnyc/thelabui/src/components/TableInContainerBlock";

import { AccordionFeatureBlock } from "../AccordionFeature";
import { AlertBlock } from "../Alert";
import { AlignedRichTextBlock } from "../AlignedRichTextBlock";
import { AppBadgesBlock } from "../AppBadges";
import { ArticlePreviewGridBlock } from "../ArticlePreviewGridBlock";
import { CateringFeatureBlock } from "../CateringFeature";
import { CocktailGridBlock } from "../CocktailGrid";
import { ContentGridBlock } from "../ContentGrid";
import { CountdownTimerBlock } from "../CountdownTimer";
import { CouponBlock } from "../Coupon";
import { CustomBackgroundImageWrapper } from "../CustomBackgroundImageWrapper";
import { DisplayCtaBlock } from "../DisplayCta";
import { FAQsBlock } from "../FAQsBlock";
import { FeatureImageBlock } from "../FeatureImage";
import { FreshCatchFeatureBlock } from "../FreshCatchFeature";
import { FullWidthMediaBlock } from "../FullWidthMedia";
import { FullWidthMediaWithCTABlock } from "../FullWidthMediaWithCTA";
import { GiftCardFeatureBlock } from "../GiftCardsFeature";
import { GroupDiningFeatureBlock } from "../GroupDiningFeature";
import { HappyHourHeroBlock } from "../HappyHourHero";
import { HappyHourOffersBlock } from "../HappyHourOffers";
import { HeadingBlock } from "../HeadingBlock";
import { HeroBlock } from "../HeroBlock";
import { IFrameBlock } from "../IFrameBlock";
import { ImageLinkBlock } from "../ImageLink";
import { LinkRowBlock } from "../LinkRow";
import { MediaGridBlock } from "../MediaGridBlock";
import { PopupModalBlock } from "../PopupModal";
import { SitemapBlock } from "../SitemapBlock";
import { SocialGridBlock } from "../SocialGridBlock";
import { TabbedFeaturesBlock } from "../TabbedFeatures";
import { TieredNavBlock } from "../TieredNavBlock";
import { TimelineBlock } from "../TimelineBlock";
import { TwoColumnFeatureBlock } from "../TwoColumnFeature";
import { TwoColumnHeroBlock } from "../TwoColumnHero";
import { UnsubscribeBlock } from "../UnsubscribeBlock";
import { VideoFeatureBlock } from "../VideoFeatureBlock";

interface Props {
    value: Value;
}

const components: StreamFieldBlockMap<Value> = {
    accordion_feature: AccordionFeatureBlock,
    alert: AlertBlock,
    app_badges: AppBadgesBlock,
    artf: AlignedRichTextBlock,
    article_preview_grid: ArticlePreviewGridBlock,
    catering_feature: CateringFeatureBlock,
    cocktail_grid: CocktailGridBlock,
    content_grid: ContentGridBlock,
    countdown_timer: CountdownTimerBlock,
    coupon: CouponBlock,
    custom_background_image_wrapper: CustomBackgroundImageWrapper,
    display_cta: DisplayCtaBlock,
    faqs: FAQsBlock,
    feature_image: FeatureImageBlock,
    fresh_catch_feature: FreshCatchFeatureBlock,
    full_width_media: (block) => (
        <FullWidthMediaBlock maxHeight="auto" value={block.value} />
    ),
    full_width_media_with_cta: FullWidthMediaWithCTABlock,
    gift_cards_feature: GiftCardFeatureBlock,
    group_dining_feature: GroupDiningFeatureBlock,
    happy_hour_hero: HappyHourHeroBlock,
    happy_hour_offers: HappyHourOffersBlock,
    heading: HeadingBlock,
    hero: HeroBlock,
    iframe: IFrameBlock,
    image_link: ImageLinkBlock,
    link_row: LinkRowBlock,
    media_grid: MediaGridBlock,
    popup_modal: PopupModalBlock,
    scroll_nav_menu_item: ScrollNavMenuItemBlock,
    sitemap: SitemapBlock,
    social_grid: SocialGridBlock,
    tabbed_features: TabbedFeaturesBlock,
    table: TableInContainerBlock,
    tiered_nav: TieredNavBlock,
    timeline: TimelineBlock,
    two_column_feature: TwoColumnFeatureBlock,
    two_column_hero: TwoColumnHeroBlock,
    unsubscribe: UnsubscribeBlock,
    video_feature: VideoFeatureBlock,
};

export const Toolbox = (props: Props) => (
    <StreamField components={components} value={props.value} />
);
